import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import PaymentService from "../../Services/PaymentService";
import { Base64 } from "js-base64";
import { BsPatchCheck } from "react-icons/bs";
import moment from "moment";
import Layout from "../../Layout";
import { APP_ROUTES } from "../../PageRouting/pageRoutes";

const CartPaymentPage = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState();

  useEffect(() => {
    getPaymentStatus();
  }, [params]);

  const decodedValues = Base64.decode(params.transactionId);
  const splitValues = decodedValues.split("|");

  const getPaymentStatus = async () => {
    try {

      const data = {
        transactionId: splitValues[0],
        patientId: splitValues[1],
        cartId: splitValues[2],
      };
      const result = await PaymentService.getTransactionStatus(data);
      if (result?.data) {
        if (result?.data.code === "PAYMENT_ERROR") {
          return navigate(APP_ROUTES.MEDICINECART);
        }
        setStatus(result.data);

    }
    } catch (error) {
      console.error("Error in getPaymentStatus:", error);
    }
  };

  const convertUTCDateLocal = (utcDate, format = "DD/MM/YYYY, HH:mm:ss") => {
    if (!utcDate) return ""; // handle null or undefined dates
    const localDate = moment.utc(utcDate).local();
    return localDate.format(format);
  };

  const handlepayment = async () => {
    let cartUpdate = {
      cartType: 2,
      modifiedBy: splitValues[1],
      patientId: splitValues[1],
    };
    const updateRes = await PaymentService.CartUpdate(splitValues[2],cartUpdate);
    navigate("/");
  };

  return (
    <Layout>
      <div>
        {status?.code === "PAYMENT_SUCCESS" ? (
          <div>
            <div className="bg-white p-6 rounded-xl shadow-lg mt-10 max-w-sm mx-auto border">
              <div className="text-center">
                <div className="bg-[#E6F2EE] w-12 h-12 rounded-full mx-auto mb-4 flex items-center justify-center">
                  <div className="bg-green-500 w-7 h-7 rounded-full mx-auto flex items-center justify-center">
                    <BsPatchCheck className="text-white" />
                  </div>
                </div>
                <div>
                  <h2 className="text-xl text-gray-600 font-medium mb-2">
                    Payment Success!
                  </h2>
                  <p className=" mb-4 font-bold">₹ {parseFloat(status?.paidAmount)}</p>
                </div>
              </div>
              <div className="border border-b-2"></div>
              <div className="m-3 ">
                <div className="flex justify-between ">
                  <p className="text-gray-600 font-medium text-base">
                    Transaction ID
                  </p>
                  <p className="text-gray-600 font-medium text-base">
                    {status?.transactionId}
                  </p>
                </div>
                <div className="flex justify-between mt-2">
                  <p className="text-gray-600 font-medium text-base">
                    Payment Time
                  </p>
                  <p className="text-gray-600 font-medium text-base">
                    {convertUTCDateLocal(status?.paidDate)}
                  </p>
                </div>
                <div className="">
                  <button
                    onClick={() => handlepayment()}
                    className="text-center border rounded-lg mt-5 w-full p-2 bg-green-500 text-white text-lg font-medium"
                  >
                    Done
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </Layout>
  );
};

export default CartPaymentPage;
